import { faBan, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { Fragment, useRef, useState, useContext } from "react";
import moment from "moment";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { Toast } from "../UI/toast/Toast";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  changeStatusPaymentProperty,
  PaymentProperty,
} from "../../helpers/api/finance";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import PageHeader from "../common/PageHeader";
import Logo from "../navbar/Logo";
import SupportLink from "../root/support/components/SupportLink";
import { useReactToPrint } from "react-to-print";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { CurrencyContext } from "../../context/Context";
import { formatAmountForBackend } from "../../helpers/currencyConversion";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import VoidPaymentModal from "./VoidPaymentModal";

const PropertyPaymentDetail = ({ setRedirect, setRedirectUrl, pay }) => {
  const moduleBase = useModuleBase();
  const { propertyPayment, id } = useParams();
  const reportRef = useRef();
  const { role } = useSelector((state) => state.auth.user);
  const { baseCurrency } = useContext(CurrencyContext);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { condominium, address } = useSelector((state) => state.condominium);
  const [collapseOne, collapseOneOpen] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
    importStyles: true,
  });

  const [params] = useState({
    status: null,
    condominiumId: selectedCondominium,
    start_date: null,
    end_date: null,
  });

  const { data: paymentsData, mutate } = useSWRFetchPaginationProperty(PaymentProperty, params);
  const payments = paymentsData || [];
  const [voidTarget, setVoidTarget] = useState(null);

  const formatDateSafe = (date) => {
    if (!date) return "";

    const raw = String(date).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const [year, month, day] = raw.split("-");
      return `${Number(day)}/${Number(month)}/${year}`;
    }

    const parsed = moment(raw);
    return parsed.isValid() ? parsed.format("D/M/YYYY") : "";
  };

  const cancel = async () => {
    try {
      const { code } = await changeStatusPaymentProperty(
        propertyPayment,
        { status: "canceled" }
      );
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments/properties`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago cancelado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const refuse = async (propertyPayment) => {
    try {
      const { code } = await changeStatusPaymentProperty(propertyPayment, {
        status: "refused",
      });
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments/properties`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago cancelado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const approve = async (propertyPayment, paymentObj) => {
    try {
      const targetPayment = paymentObj || (typeof propertyPayment === "object" ? propertyPayment : null);
      const paymentId = typeof propertyPayment === "object" ? propertyPayment?.advance_payment_id || propertyPayment?.id : propertyPayment;

      const rawAmountConverted = targetPayment?.amount_converted ?? (
        Number.isFinite(Number(targetPayment?.amount)) && Number.isFinite(Number(targetPayment?.exchange_rate?.value))
          ? Number(targetPayment.amount) * Number(targetPayment.exchange_rate.value)
          : null
      );

      const payload = {
        status: "approved",
      };

      if (rawAmountConverted !== null && rawAmountConverted !== undefined && rawAmountConverted !== "") {
        payload.amount_converted = formatAmountForBackend(rawAmountConverted);
      }

      const { code } = await changeStatusPaymentProperty(paymentId, payload);
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments/properties`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago aprobado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  return (
    <Fragment>
      <PageHeader
        title="Detalle de pago"
        titleTag="h2"
        description={
          role === "property"
            ? "Visualiza tu pago realizado."
            : "Visualiza el pago del propietario"
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>

      {payments.map(
        (pay, index) =>
         pay.advance_payment_id === Number(propertyPayment) && (
          <Fragment key={index}>
      <Card className="mb-3">
          <CardBody>
            <Row className="justify-content-between align-items-center d-flex">
              <Col md>
                <h5 className="mb-2 mb-md-0">
                  Pago #{pay.advance_payment_id}
                </h5>
              </Col>
              <Col
                xs="auto"
                lg={"auto"}
                md={12}
                className="justify-self-end d-flex justify-content-end align-items-center"
              >
                <ButtonIcon
                  color="falcon-default"
                  size="sm"
                  icon="arrow-down"
                  disabled
                  className="mr-2 mb-2 mb-sm-0"
                >
                  Descargar (.pdf)
                </ButtonIcon>
                <ButtonIcon
                  onClick={handlePrint}
                  color="falcon-default"
                  size="sm"
                  icon="print"
                  disabled={!payments.length}
                  className="mr-2 mb-2 mb-sm-0"
                >
                  Imprimir
                </ButtonIcon>
                {role === "property" && pay.status === "pending" && (
                  <ButtonIcon
                    color="falcon-danger"
                    size="sm"
                    icon={faTimes}
                    className="mb-2 mb-sm-0"
                    onClick={() => collapseOneOpen(!collapseOne)}
                  >
                    Cancelar pago
                  </ButtonIcon>
                )}
                {role === "manager" ? (
                  pay.status === "pending" ? (
                    <>
                      <ButtonIcon
                        color="falcon-success"
                        size="sm"
                        icon={faCheck}
                        className="mb-2 mr-2  mb-sm-0"
                        onClick={() =>
                          approve(pay.advance_payment_id, pay)
                        }
                      >
                        Aprobar pago
                      </ButtonIcon>
                      <ButtonIcon
                        color="falcon-danger"
                        size="sm"
                        icon={faTimes}
                        className="mb-2 mb-sm-0"
                        onClick={() => refuse(pay.advance_payment_id)}
                      >
                        Rechazar pago
                      </ButtonIcon>
                    </>
                  ) : pay.status === "approved" ? (
                    <ButtonIcon
                      color="falcon-danger"
                      size="sm"
                      icon={faBan}
                      className="mb-2 mb-sm-0"
                      onClick={() => setVoidTarget(pay.advance_payment_id)}
                    >
                      Anular saldo a favor
                    </ButtonIcon>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
            {pay.status === "voided" && (
              <Alert color="danger" className="shadow-sm fs--1">
                <strong className="d-block">Abono anulado</strong>
                {pay.void_reason && (
                  <span className="d-block">Motivo: {pay.void_reason}</span>
                )}
                <span className="d-block fs--2">
                  {`Anulado el ${formatDateSafe(pay.voided_at)}${pay.voided_by_name ? ` por ${pay.voided_by_name}` : ""}`}
                </span>
              </Alert>
            )}
            <Card

              innerRef={(e) => {
                reportRef.current = e;
              }}
            >
              <CardBody>
                <Row className="align-items-center text-center mb-3">
                  <Col sm={6} className="text-sm-left">
                    <div className="text-sm-left col-sm-6">
                      <Logo width={150} />
                    </div>
                  </Col>
                  <Col className="text-sm-right mt-3 mt-sm-0">
                    <h2 className="mb-3">Abono de propietario</h2>
                    <h5>{condominium}</h5>
                    <p className="fs--1 mb-0">{address}</p>
                  </Col>
                  <Col xs={12}>
                    <hr />
                  </Col>
                </Row>
                <Row className="justify-content-between align-items-center">
                  <Col>
                    <h6 className="text-500">Factura de pago para</h6>
                    <h5>
                        {pay?.property?.user?.data?.firstname} {pay?.property?.user?.data?.lastname}
                    </h5>
                    <p className="fs--1">{pay?.property?.user?.data?.address}</p>
                    <p className="fs--1">
                      <a href={`mailto:`}>{}</a>
                      <br />
                      <a href={`tel:`}>{pay?.property?.user?.data?.phone}</a>
                    </p>
                  </Col>
                  <Col sm="auto" className="ml-auto">
                    <div className="table-responsive">
                      <Table striped size="sm" borderless className="fs--1">
                        <tbody>
       
                          <tr>
                            <th className="text-sm-right">Fecha de pago:</th>
                            <td>
                                   {pay.payment_date
                                    ? formatDateSafe(pay.payment_date)
                                        : pay.created_at
                                    ? formatDateSafe(pay.created_at)
                                        : ""}
                            </td>
                          </tr>
                          <tr
                             className={
                                      pay.status === "pending"
                                        ? "alert-warning  font-weight-bold"
                                        : pay.status === "refused"
                                        ? "alert-danger  font-weight-bold"
                                        : pay.status === "canceled"
                                        ? "alert-danger font-weight-bold"
                                        : pay.status === "voided"
                                        ? "alert-secondary font-weight-bold"
                                        : "alert-success font-weight-bold"
                                    }
                          >
                            <th className="text-sm-right">Estado:</th>
                            <td>
                                 {pay.status === "pending"
                                        ? "Pendiente"
                                        : pay.status === "refused"
                                        ? "Pago rechazado"
                                        : pay.status === "canceled"
                                        ? "Cancelado"
                                        : pay.status === "voided"
                                        ? "Anulado"
                                        : "Aprobado"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

                <div className="table-responsive mt-4 fs--1">
                  <Table striped className="border-bottom">
                    <thead>
                      <tr /* className="bg-primary text-white" */>
                        <th className="border-0">Referencia</th>
                        <th className="border-0 text-center">Fecha</th>
                        <th className="border-0 text-right">Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="align-middle">
                          {pay.reference !== null ? pay.reference : "N/A - Pago en efectivo"}
                        </td>
                        <td className="align-middle text-center">
                             {formatDateSafe(pay.created_at)}
                        </td>
                        <td className="align-middle text-right">
                               {" "}
                                  <NumberFormat
                                    displayType="text"
                                    prefix={`${baseCurrency.symbol} `}
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    value={pay.amount}
                                  />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <Row noGutters className="justify-content-end">
                  {pay.voucher && pay.voucher !== "false" && (
                    <Col>
                      <Table
                        striped
                        size="sm"
                        borderless
                        className="fs--1 text-left"
                      >
                        <thead>
                        <th className="border-0">Comprobante de pago</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                            <div className="App mt-3">
                            <img
                              src={pay?.voucher}
                              style={{
                                height: "400px",
                                width: "400px",
                                maxHeight: "400px",
                                maxWidth: "400px",
                                backgroundRepeat: "no-repeat",
                              }}
                              alt="Factura"
                            />
                          </div>
                  {/*             <div className="d-flex align-items-center justify-content-start">
                                <div
                                  style={{
                                    backgroundImage: `url('${
                                      import.meta.env.VITE_URL
                                    }/view/image/${token}?path=${
                                      pay.voucher
                                    }&size=large')`,
                                    backgroundSize: "contain",
                                    height: "400px",
                                    width: "400px",
                                    maxHeight: "400px",
                                    maxWidth: "400px",
                                    backgroundRepeat: "no-repeat",
                                  }}
                                />
                              </div> */}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  )}
                  <Col xs="auto">
                    <Table
                      striped
                      size="sm"
                      borderless
                      className="fs--1 text-right"
                    >
                      <tbody>
                        <tr className="border-top">
                          <th className="text-900">Total:</th>
                          <td className="font-weight-semi-bold">
                            <NumberFormat
                              className="text-right"
                              displayType="text"
                              allowedDecimalSeparators={true}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale
                              prefix={`${baseCurrency.symbol} `}
                              value={pay.amount}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Modal isOpen={collapseOne} data-testid="modal">
                  <ModalHeader>Confirmación</ModalHeader>
                  <ModalBody>
                    <p className="mb-0 font-weight-bold fs--1">
                      ¿Está seguro de cancelar el pago? Podrá realizar
                      nuevamente el pago.
                    </p>
                  </ModalBody>
                  <ModalFooter>
                    <Button onClick={() => collapseOneOpen(!collapseOne)}>
                      Cancelar
                    </Button>
                    <Button
                      data-testid="submit-button"
                      color="primary"
                      type="submit"
                      onClick={cancel}
                    >
                      Sí, cancelar
                    </Button>
                  </ModalFooter>
                </Modal>
              </CardBody>
            </Card>
          </Fragment>

          )
      )}
      <VoidPaymentModal
        isOpen={voidTarget !== null}
        toggle={() => setVoidTarget(null)}
        kind="advance"
        paymentId={voidTarget}
        onVoided={() => mutate()}
      />
    </Fragment>
  );
};

export default withRedirect(PropertyPaymentDetail);
